
(function() {
  try {
    var url = new URL(window.location.href);
    if (url.pathname.includes('/search')) {
      var q = (url.searchParams.get('q') || '').toLowerCase().trim();
      if (q.includes('merckens')) {
        // Redirección inmediata antes de que Shopify pinte nada
        window.location.replace('/collections/merckens');
      }
    }
  } catch (e) {
    console.error('Redirect error:', e);
  }
})();
